import {HttpClient, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {CampaignActivity} from '../models';
import {environment} from '~environments/environment';
import {CampaignActivityTranslationService} from '../../shared/translations/customer/campaign-activity-translations.service';


/**
 * Service for creating and updating invoice entity.
 */
@Injectable()
export class CampaignService {
  public API_URL: any = `${environment.envAPI}`;
  public activity: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public castActivity: any = this.activity.asObservable();

  constructor(private http: HttpClient, private actionTranslations: CampaignActivityTranslationService) {
  }

  /**
   * Get the campaign activity for a customer.
   */
  public getCampaignActivity(customerId: number): Observable<Array<CampaignActivity>> {
    return this.http.get<Array<CampaignActivity>>(`${this.API_URL}/customers/${customerId}/campaign-activity`).pipe(
      map((response: Array<CampaignActivity>) => response.map(campaignActivity => new CampaignActivity(campaignActivity, this.actionTranslations)))
    );
  }

  /**
   * Get the subscription status for a customer.
   */
  public getSubscriptionStatus(customerId: number): Observable<HttpResponse<any>> {
    return this.http.get<any>(`${this.API_URL}/customers/${customerId}?subscriptionStatus`);
  }

  /**
   * Manipulates the array to give the correct pages
   */
  public getCampaignActivityFromPage(activity: any, itemsPerPage: number): any {
    return activity.slice(0, itemsPerPage);
  }

  /**
   * Set new campaign activity
   */
  public setCampaignActivity(activity: any): void {
    this.activity.next(activity);
  }

  /**
   * Clears the campaign activity observable
   */
  public clearCampaignActivity(): void {
    this.activity.next(null);
  }
}
